// @flow

import { beginRequest, completeRequest } from "@store/utils";
import type { SpecialContactsState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);
const finishRequest = completeRequest(["requestsInProgress"]);

export const onRemoveSpecialContactType = (state: SpecialContactsState) => () =>
  startRequest(state);
export const onRemoveSpecialContactTypeSuccess = (state: SpecialContactsState) => () =>
  finishRequest(state);
export const onRemoveSpecialContactTypeError = (state: SpecialContactsState) => () =>
  finishRequest(state);

export const onAddSpecialContactType = (state: SpecialContactsState) => () => startRequest(state);
export const onAddSpecialContactTypeSuccess = (state: SpecialContactsState) => () =>
  finishRequest(state);
export const onAddSpecialContactTypeError = (state: SpecialContactsState) => () =>
  finishRequest(state);

export const onAddSpecialContact = (state: SpecialContactsState) => () => startRequest(state);
export const onAddSpecialContactSuccess = (state: SpecialContactsState) => () =>
  finishRequest(state);
export const onAddSpecialContactError = (state: SpecialContactsState) => () => finishRequest(state);

export const onRemoveSpecialContact = (state: SpecialContactsState) => () => startRequest(state);
export const onRemoveSpecialContactSuccess = (state: SpecialContactsState) => () =>
  finishRequest(state);
export const onRemoveSpecialContactError = (state: SpecialContactsState) => () =>
  finishRequest(state);

export const onUpdateSpecialContact = (state: SpecialContactsState) => () => startRequest(state);
export const onUpdateSpecialContactSuccess = (state: SpecialContactsState) => () =>
  finishRequest(state);
export const onUpdateSpecialContactError = (state: SpecialContactsState) => () =>
  finishRequest(state);

export const onGetSpecialContacts = (state: SpecialContactsState) => () => startRequest(state);
export const onGetSpecialContactsSuccess = (state: SpecialContactsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});
export const onGetSpecialContactsError = (state: SpecialContactsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: payload,
  list: {
    ...state.list,
    content: [],
  },
});

export const onSetSpecialContactsListOptions = (state: SpecialContactsState) => ({
  payload,
}: Object) => ({
  ...state,
  listOptions: payload,
});

export const onSetCurrentSpecialContact = (state: SpecialContactsState) => ({
  payload,
}: Object) => ({
  ...state,
  current: payload,
});

export const onGetSpecialContactsEmployees = (state: SpecialContactsState) => () =>
  startRequest(state);
export const onGetSpecialContactsEmployeesSuccess = (state: SpecialContactsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  employeesList: payload,
});
export const onGetSpecialContactsEmployeesError = (state: SpecialContactsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: payload,
  employeesList: {
    ...state.employeesList,
    content: [],
  },
});

export const onClearSpecialContactsEmployees = (state: SpecialContactsState) => (action: *) => ({
  ...state,
  employeesList: null,
});

export const onSetShowAddSpecialContactModal = (state: SpecialContactsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddModal: payload,
  },
});

export const onSetShowEditSpecialContactModal = (state: SpecialContactsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditModal: payload,
  },
});

export const onSetShowDeleteSpecialContactModal = (state: SpecialContactsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDeleteModal: payload,
  },
});
